export default {"src":"/_next/static/media/noDataTable.7041d5df.svg","height":118,"width":157,"blurWidth":0,"blurHeight":0};